var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionItems(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#152b4d;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.53,12.44a.91.91,0,0,1,.91.91v3.91A5.47,5.47,0,0,1,16,22.72H5.46A5.47,5.47,0,0,1,0,17.26V6.74A5.47,5.47,0,0,1,5.46,1.28H16l.48,0,.11,0a3.47,3.47,0,0,1,.45.06l.12,0,.38.1.09,0,.43.16.06,0h0a5.48,5.48,0,0,1,2.38,2,.92.92,0,1,1-1.52,1,3.61,3.61,0,0,0-1.67-1.35l-.11,0-.29-.1-.11,0-.31-.05-.11,0-.41,0H5.46A3.64,3.64,0,0,0,1.82,6.74V17.26a3.64,3.64,0,0,0,3.64,3.63H16a3.64,3.64,0,0,0,3.63-3.63V13.35a.91.91,0,0,1,.92-.91m3.2-7.13a.92.92,0,0,0-1.29,0l-10,10L7.28,10.2A.91.91,0,1,0,6,11.49l5.38,5.38a1.47,1.47,0,0,0,1.05.43,1.48,1.48,0,0,0,1.05-.43L23.73,6.6a.91.91,0,0,0,0-1.29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionItems);
export default __webpack_public_path__ + "static/media/ActionItems.76db311a696d3f2d014ea5f3f9529a15.svg";
export { ForwardRef as ReactComponent };